import { useSelector } from "react-redux";
import { State } from "../../../../state/store";
import { CareRecipient } from "../../../../domain/care_recipient/CareRecipient";
import { CareRecipientId } from "../../../../domain/care_recipient/CareRecipientId";
import { CareRecipientName } from "../../../../domain/care_recipient/CareRecipientName";
import { CareRecipientHouseId } from "../../../../domain/care_recipient/CareRecipientHouseId";
import { useMemo } from "react";

export const useViewableCareRecipient = (): CareRecipient[] | null => {
    const responseJson = useSelector((state: State) => state.adminUser.viewableCareRecipients);

    // ユーザー情報の取得はAdminUserAddPage.tsx、AdminUserUpdatePage.tsxにて行う

    const careRecipientArray = useMemo(() => (
        responseJson ? responseJson.map(viewableCareRecipient => 
            CareRecipient.from(
                CareRecipientId.fromString(viewableCareRecipient.id),
                CareRecipientName.fromString(viewableCareRecipient.name),
                null,
                viewableCareRecipient.houseId ? CareRecipientHouseId.fromString(viewableCareRecipient.houseId) : null
            )
        ) : null
    ), [responseJson]);

    return careRecipientArray;
};
